var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkZone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st3434342{fill:#009AC9;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3434342",
    d: "M8.7,5.1C9,5.3,9.1,5.6,9.1,6c0,0.4-0.2,0.7-0.5,0.9C8.3,7.2,7.9,7.3,7.2,7.3H6.6V4.8h0.9 C8,4.8,8.4,4.9,8.7,5.1z M14.6,2.4v10.2c0,1.1-0.9,2-2,2H2.4c-1.1,0-2-0.9-2-2V2.4c0-1.1,0.9-2,2-2h10.2C13.7,0.4,14.6,1.3,14.6,2.4 z M11.1,6c0-0.8-0.3-1.5-0.9-1.9C9.6,3.6,8.7,3.4,7.6,3.4h-3v8.2h2V8.7h0.9c1.2,0,2.1-0.2,2.7-0.7C10.8,7.5,11.1,6.8,11.1,6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkZone);
export default __webpack_public_path__ + "static/media/parkZone.2c168dd5.svg";
export { ForwardRef as ReactComponent };